import {Platform, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 20,
    paddingVertical: 20,
    marginTop: 10,
  },
  sectionTitle: {
    marginBottom: 12,
    color: '#1C1C1E',
    fontSize: 16,
    fontFamily: 'OpenSans',
    fontWeight: '700',
  },
  photoGrid: {
    flexDirection: 'row',
    gap: 12,
  },
  photoCard: {
    flex: 1,
  },
  label: {
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 6,
  },

  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: Platform.OS === 'web' ? 260 : 140,
    borderRadius: 8,
    overflow: 'hidden',
  },
  photoImage: {
    width: '100%',
    // height: 140,
    height: Platform.OS === 'web' ? 260 : 140,
    borderRadius: 8,
  },
  uploadBox: {
    width: '100%',
    height: 140,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    borderRadius: 8,
    borderStyle: 'dashed',
    backgroundColor: '#E5E7EB',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: 10,
  },
  uploadText: {
    fontSize: 12,
    color: '#6B7280',
    textAlign: 'center',
  },
  uploadSubText: {
    fontSize: 12,
    color: '#9CA3AF',
    textAlign: 'center',
  },
  uploadTextSize: {
    fontSize: 12,
    color: '#9CA3AF',
    textAlign: 'center',
  },
  uploadIcon: {
    fontSize: 20,
    color: '#6B7280',
  },

  loaderOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255,255,255,0.3)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  disabled: {
    opacity: 0.5,
  },

  actionRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: 10,
    overflow: 'hidden',
  },

  actionRowStacked: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },

  actionBtnWrapper: {
    flex: 1,
  },

  actionBtnWrapperFull: {
    width: '100%',
  },

  actionSpacerHorizontal: {
    width: 8,
  },

  actionSpacerVertical: {
    height: 8,
  },

  actionBtn: {
    width: '100%',
    minHeight: 36,
    paddingVertical: 8,
    paddingHorizontal: 6,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },

  uploadingFullWidthBtn: {
    width: '100%',
    alignSelf: 'stretch',
  },

  confirmBtn: {
    backgroundColor: '#111827',
    borderColor: '#111827',
  },

  cancelBtn: {
    backgroundColor: '#FFFFFF',
    borderColor: '#767676',
  },

  confirmBtnText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
  },

  cancelBtnText: {
    color: '#1E1E1E',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: '600',
  },

  replaceBtn: {
    marginTop: 10,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#767676',
    borderRadius: 20,
  },
  replaceBtnText: {
    fontSize: 14,
    color: '#1E1E1E',
    textAlign: 'center',
  },

  retryContainer: {
    width: '100%',
    marginTop: 8,
    alignItems: 'flex-start',
  },
  retryTextContainer: {
    width: '100%',
    marginBottom: 6,
  },
  errorText: {
    fontSize: 13,
    color: '#DC2626',
    fontWeight: '500',
    textAlign: 'left',
  },

  retryActionRow: {
    flexDirection: 'row',
    width: '100%',
    gap: 6,
    alignItems: 'stretch',
  },

  retryActionRowStacked: {
    flexDirection: 'column',
  },

  retryBtn: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#DC2626',
    backgroundColor: '#FEF2F2',
    borderRadius: 20,
  },

  retryCancelButton: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 44,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 12,
  },

  retryBtnText: {
    fontSize: 12,
    color: '#DC2626',
    fontWeight: '600',
    textAlign: 'center',
    flexShrink: 1,
  },

  retryCancelText: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '600',
    textDecorationLine: 'underline',
    color: '#6B7280',
    textAlign: 'center',
    flexShrink: 1,
  },

  fullWidthBtn: {
    width: '100%',
  },
});
